(function( $ ){
    $( '.update-reimbursement' ).on('click', function(){
        $( '.update-reimbursement legend button' ).hide();
        $( '.update-reimbursement legend span' ).show();
        $( '.update-reimbursement form' ).show();
    } );
})( jQuery );
